import { render, staticRenderFns } from "./dev-page.vue?vue&type=template&id=4a356825"
import script from "./dev-page.vue?vue&type=script&lang=js"
export * from "./dev-page.vue?vue&type=script&lang=js"
import style0 from "./dev-page.vue?vue&type=style&index=0&id=4a356825&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports